// URL da tela de documentos do ZDocs standalone (migração ZC-MigracaoZdocs).
// Devolve null quando o ambiente não tem ZDocsURL: quem chama cai no GED interno, sem regressão.
// empresaId vai dentro do hash — o auth-guard do ZDocs lê ?empresaId da query OU do hash.
export const zdocsDocumentosUrl = (empresaId, pastaId) => {
  const base = process.env.ZDocsURL
  if (!base) return null
  const params = []
  if (empresaId) params.push(`empresaId=${encodeURIComponent(empresaId)}`)
  if (pastaId) params.push(`pastaId=${encodeURIComponent(pastaId)}`)
  return `${base}/#/documentos${params.length ? `?${params.join('&')}` : ''}`
}

// Entrada pelo SSO: a aba do zcloud vai pra pagina inicial e o ZDocs abre em outra aba. Sem clique
// do usuario o navegador costuma bloquear o pop-up; nesse caso a URL fica guardada e a StartPage
// mostra o botao "Abrir ZDocs" (o clique dele nao e bloqueado).
const ZDOCS_PENDENTE = 'zdocsPendente'

export const abrirZDocsEmNovaAba = (url) => {
  // Sem 'noopener' nas features: com ele o window.open devolve null sempre e nao da pra saber se
  // o navegador bloqueou. O opener e cortado logo em seguida.
  const aba = window.open(url, '_blank')
  if (aba) {
    aba.opener = null
    sessionStorage.removeItem(ZDOCS_PENDENTE)
    return true
  }
  sessionStorage.setItem(ZDOCS_PENDENTE, url)
  return false
}

export const zdocsPendente = () => sessionStorage.getItem(ZDOCS_PENDENTE)
export const limparZDocsPendente = () => sessionStorage.removeItem(ZDOCS_PENDENTE)

export default { zdocsDocumentosUrl, abrirZDocsEmNovaAba, zdocsPendente, limparZDocsPendente }



// WEBPACK FOOTER //
// ./src/shared/utils/zdocs.js